import React, { Fragment, useEffect, useState } from "react";

import SideBar from "./SideBar";
import NavHader from "./NavHader";
import Header from "./Header";
//import RightSideBar from "./RightSideBar";
import ChatBox from "../ChatBox";

const JobieNav = ({ title, onClick: ClickToAddEvent, onClick2, onClick3 }) => {
  const [toggle, setToggle] = useState("");
  const onClick = (name) => setToggle(toggle === name ? "" : name);

  useEffect(() => {
    const closeMobileSidebarOnOutsideTap = (event) => {
      const body = document.body;
      const sidebarStyle = body.getAttribute("data-sidebar-style");
      const mainWrapper = document.getElementById("main-wrapper");
      const overlayOpen = sidebarStyle === "overlay" && mainWrapper?.classList.contains("menu-toggle");
      const miniExpanded = sidebarStyle === "mini" && body.classList.contains("mini-expanded");
      if (!overlayOpen && !miniExpanded) return;
      if (event.target.closest(".deznav")) return;
      if (event.target.closest(".nav-control")) return;
      // A guided tour opens the drawer to spotlight items inside it. Driver.js
      // stamps body.driver-active for the tour's lifetime and every popover
      // control carries the .driver-popover class, so a tap on Back or Next
      // would otherwise register as an outside tap and slam the drawer shut
      // between steps. Skip while a tour is running or the tap lands on the
      // driver popover itself.
      if (body.classList.contains("driver-active")) return;
      if (event.target.closest(".driver-popover")) return;
      if (overlayOpen) {
        mainWrapper.classList.remove("menu-toggle");
        document.getElementById("side-menu-hambuger-reveal")?.classList.remove("is-active");
      }
      if (miniExpanded) {
        body.classList.remove("mini-expanded");
      }
    };
    document.addEventListener("mousedown", closeMobileSidebarOnOutsideTap);
    document.addEventListener("touchstart", closeMobileSidebarOnOutsideTap);
    return () => {
      document.removeEventListener("mousedown", closeMobileSidebarOnOutsideTap);
      document.removeEventListener("touchstart", closeMobileSidebarOnOutsideTap);
    };
  }, []);

  return (
    <Fragment>
	  
      <NavHader />
      <ChatBox onClick={() => onClick("chatbox")} toggle={toggle} />
      <Header
          onNote={() => onClick("chatbox")}
          onNotification={() => onClick("notification")}
          onProfile={() => onClick("profile")}
          toggle={toggle}
          title={title}
          onBox={() => onClick("box")}
          onClick={() => ClickToAddEvent()}
        /> 
      <SideBar />
    </Fragment>
  );
};

export default JobieNav;
